module.exports = __webpack_public_path__ + "img/75722.735e96f1.svg";